const p = {
  2: "2px",
  3: "3px",
  4: "4px",
  6: "6px",
  8: "8px",
  12: "12px",
  16: "16px",
  24: "24px",
  32: "32px",
  38: "38px",
  40: "40px",
  44: "44px",
  48: "48px",
  56: "56px",
  60: "60px",
  64: "64px",
  72: "72px",
  80: "80px"
};
export {
  p as SPACING_PRIMITIVE
};
//# sourceMappingURL=index.es2362.js.map
